<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 7h-2V5a2 2 0 00-2-2H9a2 2 0 00-2 2v2H5a2 2 0 00-2 2v14a2 2 0 002 2h2v2a2 2 0 002 2h14a2 2 0 002-2v-2h2a2 2 0 002-2V9a2 2 0 00-2-2zM9 5h14v2H9zm14 22H9v-9h14zm4-4h-2v-5a1 1 0 000-2H7a1 1 0 000 2v5H5V9h22z"/><path d="M21.5 12H25a.5.5 0 000-1h-3.5a.5.5 0 000 1zM11.5 21h9a.5.5 0 000-1h-9a.5.5 0 000 1zM11.5 24.5h9a.5.5 0 000-1h-9a.5.5 0 000 1z"/></svg>